export default "__VITE_ASSET__DpuSrdHn__"